export default __webpack_public_path__ + "static/media/ProximaNova-Sbold.59966cf4.woff";